import React from 'react'
import FilterPanel from '../components/FilterPanel';
import StatsPanel from '../components/StatsPanel';
import CropCard from '../components/CropCard';
import NoResults from '../components/NoResults';
import cropData from '../data/cropData';

function PresetPage({ language, searchTerm, setSearchTerm, selectedCategory, setSelectedCategory, categories, filteredCrops, translations: t }) {
  return (

       <div>
        <section id="product" className="bg-white py-4">
                <div className="max-w-7xl mx-auto px-4 md:px-5">
                  <h2 className="text-3xl font-bold mb-2" style={{ color: '#427300' }}>{t.productsTitle}</h2>
                  <p className="text-slate-600 mb-8">{t.productsSubtitle}</p>
                </div>
              </section>
        
       <main className="flex-grow max-w-7xl mx-auto px-4 md:px-5 py-8 md:py-12 w-full">
         <StatsPanel crops={cropData} translations={t} />
       <FilterPanel categories={categories} selectedCategory={selectedCategory} onCategoryChange={setSelectedCategory} language={language} translations={t} onSearch={setSearchTerm} />

         <div className="mb-8">
          {filteredCrops.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {filteredCrops.map((crop, index) => (
                <div key={`${crop.name}-${index}`} className="animate-fadeIn" style={{ animationDelay: `${Math.min(index * 0.05, 0.3)}s` }}>
                  <CropCard crop={crop} language={language} />
                </div>
              ))}
            </div>
          ) : (
            <NoResults message={t.noResults} />
          )}
        </div>

        {filteredCrops.length > 0 && (() => {
          const count = filteredCrops.length;
          const cropWord = count !== 1 ? t.cropPlural : t.cropSingular;
          const countEl = <span className="text-emerald-600 font-bold">{count}</span>;
          const catName = selectedCategory !== 'all' ? (t.catNames?.[selectedCategory] || selectedCategory) : null;

          return (
            <div className="text-center text-slate-600 text-sm mt-8 p-4 bg-emerald-50 rounded-xl border border-emerald-200">
              <p className="font-semibold">
                {language === 'en' ? (
                  <>
                    {t.showingPrefix} {countEl} {cropWord}
                    {catName && ` ${t.inCategory} ${catName}`}
                    {searchTerm && ` ${t.matchingSearch} "${searchTerm}"`}
                  </>
                ) : (
                  <>
                    {countEl} {cropWord}
                    {catName && ` ${catName} ${t.inCategory}`}
                    {searchTerm && ` "${searchTerm}" ${t.matchingSearch}`}
                    {' '}{t.showingPrefix}
                  </>
                )}
              </p>
            </div>
          );
        })()}
      </main>
    </div>
    
  )
}

export default PresetPage
